import { ProjectRenderer } from '../ProjectRenderer';
import { RendererMode, UserDataObjectType, UserDataProp } from '../types';
import { InputHandler } from './InputHandler';

export class CursorHandler {
	constructor(
		private renderer: ProjectRenderer,
		private mouse: InputHandler
	) {}

	setCursorType() {
		if (this.renderer.isTouchDevice) return;

		switch (this.renderer.mode) {
			case RendererMode.CUSTOM_SHAPE_DRAWING:
			case RendererMode.MEASURING:
				document.body.style.cursor = 'pointer';
				return;

			default:
				break;
		}

		const hoveredObject = this.mouse.hoveredObject;

		if (!hoveredObject) {
			document.body.style.cursor = 'default';
			return;
		}

		const objectType = hoveredObject.userData[UserDataProp.OBJECT_TYPE];

		switch (objectType) {
			case UserDataObjectType.PROJECT:
				break;
			case UserDataObjectType.COLLIDABLE_OBJECT:
				document.body.style.cursor = 'pointer';
				break;

			default:
				throw new Error('INVALID_OBJECT_TYPE');
		}
	}
}
